import { AnyObject } from 'final-form';

export function getDirtyFields(
  values: AnyObject,
  initialValues: AnyObject,
  keys: string[],
) {
  return keys.filter((key) => values[key] !== initialValues[key]);
}
